/* @flow */

import BankAccount from 'models/companies/bankAccount';

export default class UserCompanyRoleDebtor {
  bankAccount: BankAccount;
  canExecute: boolean;
}
